module.exports = __webpack_public_path__ + "static/media/UploadDownloadAdmin.eca0af15.PNG";